module.exports = __webpack_public_path__ + "img/hand-heart.cd3ce79b.svg";